import { Chart } from 'chart.js';
import { ChartIndicatorLine } from './ChartIndicatorLine';
import { LimitReachedChip } from './LimitReachedChip';

const LIMIT_LINE_COLOR = '#F66F1E';

export const LimitReachedLine = ({
  chart,
  dataIndex,
  left,
  label,
}: {
  chart: Chart;
  dataIndex: number;
  /** Horizontal center of the chip, in canvas pixels. */
  left: number;
  label: string;
}) => (
  <>
    <ChartIndicatorLine
      chart={chart}
      id={`limit-reached-indicator-${dataIndex}`}
      dataIndex={dataIndex}
      color={LIMIT_LINE_COLOR}
    />
    <div
      className='absolute pointer-events-none flex justify-center'
      style={{ left, top: 0, transform: 'translateX(-50%)' }}
    >
      <LimitReachedChip label={label} />
    </div>
  </>
);
